/** Analytics permission strings (mirror backend PermissionCatalog). */
export const AnalyticsPermissions = {
  adminQueryRecruitment: 'admin_query_recruitment',
  access: ['admin_query_recruitment'] as const,
} as const
